// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hg6p","right":"styles_right__26ykH"};